export function containsSearch(haystack: string | null | undefined, query: string): boolean {
	const q = query.trim().toLowerCase();
	if (!q) return true;
	return (haystack ?? '').toLowerCase().includes(q);
}

export function clientMessageMatchesSearch(
	message: { sender?: string; text?: string },
	query: string,
): boolean {
	if (!query.trim()) return true;
	return containsSearch(message.sender, query) || containsSearch(message.text, query);
}

export function clientPushMatchesSearch(
	push: { packageName?: string; title?: string | null; text?: string | null },
	query: string,
): boolean {
	if (!query.trim()) return true;
	return (
		containsSearch(push.packageName, query) ||
		containsSearch(push.title, query) ||
		containsSearch(push.text, query)
	);
}

export function clientBalanceMatchesSearch(
	balance: { text?: string; sender?: string; cardNumber?: string | null },
	query: string,
): boolean {
	if (!query.trim()) return true;
	return (
		containsSearch(balance.text, query) ||
		containsSearch(balance.sender, query) ||
		containsSearch(balance.cardNumber, query)
	);
}

export function clientUssdMatchesSearch(
	ussd: { operator?: string; usedCommand?: string; response?: string; phone?: string },
	query: string,
): boolean {
	if (!query.trim()) return true;
	return (
		containsSearch(ussd.operator, query) ||
		containsSearch(ussd.usedCommand, query) ||
		containsSearch(ussd.response, query) ||
		containsSearch(ussd.phone, query)
	);
}

export function clientActionMatchesSearch(
	action: { type?: string; params?: Record<string, unknown> | null },
	query: string,
): boolean {
	if (!query.trim()) return true;
	const params = (action.params ?? {}) as Record<string, unknown>;
	return (
		containsSearch(action.type, query) ||
		containsSearch(String(params.text ?? ''), query) ||
		containsSearch(String(params.phone ?? ''), query)
	);
}
